/**
 * Prevzato z api, kde je to privatni metoda
 * @param  {SceneCoords} point
 * @param  {Array} polygon
 * @return {Boolean}
 */
export function pointInPolygonTest(point: Array<number>, polygon: Array<Array<number>> | Array<Array<Array<number>>>): boolean {
	let crossings = 0;
	const polygons = typeof polygon[0][0] === "number" ? [polygon] : polygon;

	for (let ind = 0; ind < polygons.length; ind++) {
		for (let index = 0; index < polygons[ind].length; index++) {
			const p1 = polygons[ind][index ? index - 1 : polygons[ind].length - 1];
			const p2 = polygons[ind][index];

			if (
				(p1[1] <= point[1] && p2[1] > point[1]) // an upward crossing
				|| (p1[1] > point[1] && p2[1] <= point[1]) // a downward crossing
			) { // compute the actual edge-ray intersect x-coordinate
				const vt = (point[1] - p1[1]) / (p2[1] - p1[1]);

				// point[0] < intersect
				if (point[0] < p1[0] + (vt * (p2[0] - p1[0]))) {
					crossings++;
				}
			}
		}
	}

	return !!(crossings & 1);
}
